/**
 * Removes all types of space characters from a string
 * This includes regular spaces, non-breaking spaces, and other Unicode space characters
 */
export function removeAllSpaces(input: string): string {
  return input
    .replace(/[\s\u00A0\u2000-\u200A\u202F\u205F\u3000]/g, '') // All space characters
    .replace(/\u200B/g, '') // Remove zero-width spaces
    .replace(/\u200C/g, '') // Remove zero-width non-joiners
    .replace(/\u200D/g, '') // Remove zero-width joiners
}
